import { useMutation } from '@apollo/client';
import { showToast } from 'components/common/CustomToast';
import { UPDATE_VEHICLE } from 'graphql/mutations/updateVehicle';
import {
  Mutation,
  MutationUpdateVehicleArgs,
} from 'types/generatedSchemaTypes';

const useUpdateVehicleMutation = () => {
  const [updateVehicle, { loading: updating }] = useMutation<
    Mutation,
    MutationUpdateVehicleArgs
  >(UPDATE_VEHICLE, {
    onError: (error) => {
      const errorCode = error.graphQLErrors
        .flatMap((e) => e.extensions?.code as string)
        .find((code) => code.startsWith('CANNOT_UPDATE_VEHICLE'))
        ?.split('_')
        ?.pop();
      if (errorCode) {
        showToast(
          `error.updateVehicle${
            errorCode[0] + errorCode.slice(1).toLowerCase()
          }`,
          'error'
        );
      } else {
        showToast('error.updateVehicle', 'error');
      }
    },
  });

  return { updateVehicle, updating };
};

export default useUpdateVehicleMutation;
